export default Object.freeze({
  AUTHN_WORKFLOWS: {
    AUTHORIZE: 'Authorize',
    FHIRAUTHORIZE: 'FhirAuthorize',
    AUTHORIZEVIAIDP: 'AuthorizeViaIDP',
    MANAGEPROFILE: 'ManageProfile',
  },
  LOGIN_CONTAINER_ID: 'okta-login-container',
  // appType value carried in the pre-authn response.
  PATIENT_APP_TYPE: 'patient',
  // The athenaPatient app appends this to its authorize URL; only 'new' opts in.
  LOGIN_EXPERIENCE_PARAM: 'loginExperience',
  NEW_LOGIN_EXPERIENCE: 'new',
});
